const Selectors = {
  widget: {
    target: "#root",
    waitFor: "#root",
    mobileWidgetTarget: "#root",
    mobileWidgetFixedTarget:
      '[data-testid="mobileButtons"], [data-testid="summarySubmit"]',
    widget: "#guestbook-widget",
    stickyWidget: "#guestbook-sticky-widget",
  },
  ratesPage: {
    waitFor: '.availability__rates, [data-testid="rate-table"]',
    contentChangeTarget: "[data-testid] .price, .MuiGrid2-root",
    rates:
      "ul.availability__rates div > span.price [data-testid='price'], div[data-testid='availability-results'] .MuiStack-root > span.price [data-testid='price']",
    ratesParentElement: "ul.availability__rates small",
    ratesCodes: ".thumb-cards_container .thumb-cards_rate", // attr data-rate-code
    ratesContainers: ".thumb-cards_groupedCards > div",
    ratesMessage: ".gb-rates-message", // attr data-room-code
    roomsCode: ".thumb-cards_cardSplit",
    bannerTarget: ".price",
    currencyParent: "#currency_sel",
    currency: "#currency_sel",
    promoCode: "#Code",
    subtotal: 'span[data-testid="price"]',
    selectedRooms:  '.MuiDrawer-paperAnchorRight .MuiStack-root[data-testid="roomItem"]',
  },
  paymentPage: {
    waitFor: "#billing_firstname",
    contentChangeTarget: ".MuiPaper-root.MuiDrawer-paper, #root",
    firstname: "#billing_firstname",
    lastname: "#billing_lastname",
    email: "#billing_email",
    subtotal: 'span[data-testid="price"]',
    total: ".res-item-table .total",
    checkin: "bookings[0][checkInDate]",
    checkout: "bookings[0][checkOutDate]",
    roomName: "",
    rateName: "",
    rooms: ".res-room-container",
    adults: "bookings[0][adults]",
    promoCode: "bookings[0][promoCode]",
    selectedRooms: '.MuiDrawer-paperAnchorRight .MuiStack-root[data-testid="roomItem"]',
    rateCode: ".container-group.rv-container .full-width.res-item-table",
    enrollmentTarget: "#billing_email",
    enrollmentMessageContainer: "#guestbook-enrollment",
    rewardsMessageTarget: "",
    saveInfoTarget: '[data-testid="summarySubmit"]',
  },
  confirmationPage: {
    waitFor: '[data-testid="bookingReference"]',
    messageTarget: '[data-testid="confirmation"] div',
    confirmationMessageContainer: "#guestbook-confirm",
    confirmationNumber: '[data-testid="bookingReference"]',
    contentChangeTarget: ".bp-container.bp-confirm",
    targetEmail: ".booking-summary-reservations_guestEmail",
    total: '.MuiBox-root [data-testid="price_total"]',
    cancellationNumber: '[data-testid="booking-reference"]',
    cancellationTarget:
      ".MuiCardContent-root .MuiGrid-root .MuiButtonBase-root.Mui-disabled",
  },
};

export default Selectors;
